export * from './termsAndPrivacy'
export * from './styles'
